import { PaginationAndColumnVisibilityHoc } from "@shared/components";
import PublisherDataGrid from "../components/PublisherDataGrid";
import PublisherHeader from "../components/PublisherHeader";
import { ColumnOptions, DefaultHiddenColumns } from "../utils/constants";
import { PublishersProps } from "../utils/types";

const Publishers = ({
  visibleColumns,
  setVisibleColumns,
  paginationModel,
  setPaginationModel,
}: PublishersProps) => {
  return (
    <>
      <PublisherHeader
        setPaginationModel={setPaginationModel}
        visibleColumns={visibleColumns}
        setVisibleColumns={setVisibleColumns}
      />
      <PublisherDataGrid
        visibleColumns={visibleColumns}
        setPaginationModel={setPaginationModel}
        paginationModel={paginationModel}
      />
    </>
  );
};

// Map column options to match the expected format in HOC
const transformedColumnOptions = ColumnOptions.map((option) => ({
  ...option,
  field: option.value,
}));

const TransformedPublishers = PaginationAndColumnVisibilityHoc(Publishers, {
  columnOptions: transformedColumnOptions,
  defaultHiddenColumns: DefaultHiddenColumns,
  storageKey: "publisherVisibleColumns_v1",
});

export default TransformedPublishers;
